import { Component, OnInit } from '@angular/core';
import { GlobalesService } from 'src/app/servicios/globales.service';
import { ObtenerDatosService } from '../../../../servicios/datos/obtener-datos/obtener-datos.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ThemeService } from '../../../../theme/theme.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-movil-catalogos',
  templateUrl: './movil-catalogos.component.html',
  styleUrls: ['./movil-catalogos.component.scss']
})
export class MovilCatalogosComponent implements OnInit {
  config:any = {};
  safeURL:any = ""
  startVideo = false
  existeGobernatura = false
  existeDiputaciones = false
  existeAyuntamientos = false
  habilitar_label_regidurias = false
  selectedOption = 0;
  selectedOptionLabel = "Definición";

  constructor(
    public readonly globalService: GlobalesService,
    public readonly _obtenerDatosService: ObtenerDatosService,
    private _sanitizer: DomSanitizer,
    public themeService: ThemeService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.globalService.menuActual = 'BaseDatos';
    this.globalService.unselectContiendas();
    const parametro = this.route.snapshot.paramMap.get('tipo');
    this.checkBdType(parametro);

    this._obtenerDatosService.configSubject.subscribe(data =>{
      if (data != null){ 
        this.config = data;
        this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(data.url_video + "?autoplay=1");
        console.log("URL ", this.safeURL)
        const habilLbl = data.habilitar_label_regidurias;
        this.habilitar_label_regidurias = (!habilLbl || (habilLbl && (habilLbl == 'false' || habilLbl == false) )) ? false : true;
      }
    });
    this._obtenerDatosService.mainSubject.subscribe(data =>{
      this.existeGobernatura = (data != null && data["gubernatura"]);
      this.existeDiputaciones = (data != null && data["diputaciones"]);
      this.existeAyuntamientos = (data != null && data["ayuntamientos"]);
    });
  }

  selectedOptionCallback(el: any) {
    //Fix del contexto de la variable 
    let scope = (this instanceof GlobalesService)? this["bottomSheetContex"] : this;
    console.log("selectedOptionCallback this: ", this)
    console.log({el})
    scope.checkBdType(el);
    scope.globalService.toggleBottomSheet(false);
  }

  openMenuType(){
    this.globalService.bottomSheetTpl = "base-datos";
    this.globalService.bottomSheetContex = this;
    this.globalService.bottomSheetCallback = this.selectedOptionCallback;
    this.globalService.toggleBottomSheet(true);
  }

  private checkBdType(parametro: String){
    this.selectedOption = parametro == 'definicion' ? 0 : ( parametro == 'carpeta' ? 1 : 2 );
    this.selectedOptionLabel = parametro == 'definicion' ? "Definición" : ( parametro == 'carpeta' ? 'Carpeta de archivos' : 'Consulta' );
  }

}
